import ScheduledReportForm from './ScheduledReportForm/index';

export default ScheduledReportForm;
